<template>
    <div>
        <v-card style="height:43vh" color="rgba(255,255,255,0.69)">
            <v-tooltip v-model="show" color="primary" top max-width="210">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        style="position: absolute; right: 6px;"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="ledger_dialog = true"
                    >
                        <v-icon small color="primary darken-2">mdi-alert-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span></span>
                <h4>Ledger</h4>
                <p>ardkon is assuring transparency & proof through a decentralized public ledger.</p>
            </v-tooltip>
            <v-card-subtitle class="text-center font-weight-bold primary--text">
                ledger
                <br />
                <span class="success--text">total donation: {{ total }} EUR</span>
            </v-card-subtitle>
            <v-dialog v-model="ledger_dialog" max-width="900">
                <v-card>
                    <v-card-title>Ledger</v-card-title>
                    <v-card-text>
                        Each transaction (in- and out) made is registered and has a complete transaction proof under through the ardkon ledger system
                        an ardkon token is created for each 1 USD donated.Once a donation happens the amount of token are sent to the concerned initiative. The initiatives are collecting these tokens in their accounts. Upon distribution, the swap of dollars and token is done respectively.
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-row class="ledger" no-gutters>
                <v-col v-for="item in ledger" :key="item.item_id" cols="12">
                    <LedgerItem :item="item"></LedgerItem>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import LedgerItem from './LedgerItem.vue'
import store from '@/store'
export default {
    name: 'ledger',
    components: {
        LedgerItem
    },
    data() {
        return {

            ledger_dialog: false,
            ledger_p: [
                {
                    item_id: '155632vwd-dw4w544dw-dw44d7w',
                    item_dialogue: false,
                    item_name: 'item Name',
                    venue_name: 'venue Name',
                    item_donation_amount: '25$',
                    item_small_description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    item_description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
                    item_linked_in_url: '',
                    item_website_url: '',
                    item_instagram_url: '',
                    item_facebook_url: '',
                    item_img_src: 'https://ard-platform.s3.eu-central-1.amazonaws.com/profile-members/hero-to-back-1614070289684.png'
                }, {
                    item_id: '155632vwd-dw4w544dw-dw44d7w',
                    item_dialogue: false,
                    venue_name: 'venue Name',

                    item_donation_amount: '28$',
                    item_name: 'item Name',
                    item_small_description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    item_description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
                    item_linked_in_url: '',
                    item_website_url: '',
                    item_instagram_url: '',
                    item_facebook_url: '',
                    item_img_src: 'https://ard-platform.s3.eu-central-1.amazonaws.com/profile-members/hero-to-back-1614070289684.png'
                }, {
                    item_id: '155632vwd-dw4w544dw-dw44d7w',
                    item_dialogue: false,
                    item_donation_amount: '15$',
                    venue_name: 'venue Name',

                    item_name: 'item Name',
                    item_small_description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    item_description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?',
                    item_linked_in_url: '',
                    item_website_url: '',
                    item_instagram_url: '',
                    item_facebook_url: '',
                    item_img_src: 'https://ard-platform.s3.eu-central-1.amazonaws.com/profile-members/hero-to-back-1614070289684.png'
                },

            ]
        }
    },
    computed: {
        ledger() {
            return store.state.donations.transactions
        },
        total() {
            var total = 0
            for (var i = 0; i < store.state.donations.transactions.length; i++) {
                total = total + store.state.donations.transactions[i].transaction_value
            }

            return total
        }
    }
}
</script>
<style>
.ledger {
    max-height: 33vh;
    overflow-y: scroll;
}
</style>